/*
 * @Description:
 * @Date: 2018-12-21 17:02:06
 */
import sa from 'sa-sdk-javascript';
import dateFormat from '@/tools/dateFormat';
// TODO:  兼容老版本神策方法 神策全改后删除
window.sa = sa;
export default class scClass {
  // 储存上页面信息的session key
  static sessionKey = 'sainitdata';
  constructor() {
    this.frompage_url = '';
    this.frompage_name = '';
    this.store = sa.store;
    this.registerData = {
      platform: 'asp',
      operation_tm: dateFormat(Date.now()), // 上报时间
      frompage_name: '', // 上页面name
      frompage_url: '', // 上页面url
      currentpage_name: '', // 当前页
      currentpage_url: '', // 当前页
      fromcode: '', // 页面来源code  xxx?isTemp=1,2,3,4,5
      version: process.env.VUE_APP_VERSION,
      env: process.env.NODE_ENV

      // is_share:'' // 是否分享进入
    };
    this.typeList = [
      {
        label: '直播',
        value: 5
      },
      {
        label: '录播',
        value: 6
      },
      {
        label: '资讯',
        value: 3
      },
      {
        label: '病例',
        value: 2
      },
      {
        label: '帖子',
        value: 8
      }
    ];
  }
  getSaSessionData() {
    let sessionkey = scClass.sessionKey;
    let se = sessionStorage.getItem(sessionkey);
    if (se) {
      sessionStorage.removeItem(sessionkey);
      se = JSON.parse(se);
    } else {
      se = null;
    }
    return se;
  }
  /*
   用于href 前保存当前页面信息 当作后续页面 上页面信息
   @params {vue_route || {frompage_url,frompage_name},href_url}
   */
  setSaSession_href(route, url) {
    if (typeof route != 'object') {
      console.error('saSessionData 类型参数类型错误');
    } else {
      if (route.fullPath) {
        sessionStorage.setItem(
          scClass.sessionKey,
          JSON.stringify({
            frompage_url: route.fullPath,
            frompage_name: route.meta.pageName
          })
        );
      } else {
        if (route.frompage_url) {
          sessionStorage.setItem(scClass.sessionKey, JSON.stringify(route));
        } else {
          console.error(
            'setSaSessionData页面参数设置有误!必须有当前route实例或OBJ'
          );
        }
      }
    }
    window.location.href = url ? url : '/html/newWechat.html';
  }
  //初始化神测
  init() {
    sa.init({
      server_url: '//data-api.myxrk.com/sa?project=default',
      // config_url: 'https://data.yxvzb.com:8007/api/vtrack/config',
      // send_type:'ajax',
      show_log: true, // log
      is_single_page: true //设置成 true 后， 表示在单页面开发的网站中，我们会对 hashchange 和 popstate 事件进行监听，当这两个事件任何一个发生时，也会发送 $pageview 事件。默认 false。详情参考 7.9 节。
    });
  }
  // 登陆 (标识用户) 并且给用户设置默认属性
  login(id) {
    id && sa.login(`${this.registerData.platform}_${id}`);
  }
  // @params {data} 混合属性  公共属性
  registerPage(data) {
    let isTemp = [
      {
        label: '首关',
        value: 1
      },
      {
        label: '菜单',
        value: 2
      },
      {
        label: '模板消息',
        value: 3
      },
      {
        label: '客服消息',
        value: 4
      },
      {
        label: '图文消息',
        value: 5
      },
      {
        label: '社群空间',
        value: 6
      }
    ];
    let sessionObj = this.getSaSessionData();
    if (sessionObj && sessionObj.frompage_url) {
      this.registerData = {
        ...this.registerData,
        ...data,
        ...sessionObj
      };
    } else {
      this.registerData = {
        ...this.registerData,
        ...data
      };
    }
    if (this.registerData.frompage_name) {
      isTemp.forEach(item => {
        if (item.value == this.registerData.frompage_name) {
          this.registerData.frompage_name = item.label;
        }
      });
    }
    // 神策公共属性 有乱码问题
    // sa.registerPage(modelData);
    // this.registerData = modelData
  }

  /*
  track方法封装
  @params {事件名称,时间属性}
   */
  saEvent(eventName, s = {}, fn) {
    sa.track(eventName, {
      ...s,
      ...this.registerData
    });
  }
  // 浏览路径
  re_pageview(data) {
    this.saEvent('re_pageview');
  }

  // 判断 位置
  location_func() {
    let location = '';
    let currentpage_name = this.registerData.currentpage_name;
    if (currentpage_name.includes('专区')) {
      location = '专区内';
    } else if (currentpage_name.includes('面对面')) {
      location = '超级面对面内';
    } else if (currentpage_name.includes('搜索')) {
      location = '搜索';
    } else if (currentpage_name.includes('我的收藏')) {
      location = '我的收藏';
    } else if (currentpage_name.includes('听课记录')) {
      location = '听课记录';
    } else if (currentpage_name.includes('专题')) {
      location = '专题';
    } else if (currentpage_name.includes('商业外链')) {
      location = '商业外链';
    } else {
      location = '首页';
    }
    return location;
  }

  //内容消费
  re_contentview(data) {
    let modelData = {
      type: '', // 消费类型 直播，录播，资讯，病例，看课时长上报 专题
      name: '', // 内容名字
      release_dt: '', // 直播时间/发布时间 直播是直播时间，录播是发布时间，资讯、病例是发布时间
      contentid: '', // 内容id
      first_cate: '', //一级分类
      second_cate: '', // 2级分类
      first_cate_id: '', // 1级分类id
      second_cate_id: '', //2级分类id
      author: '', //讲师/作者
      page_location: '' //位置 站内，专区内，超级面对面内
    };
    modelData.page_location = this.location_func();
    this.saEvent('re_contentview', {
      ...modelData,
      ...data
    });
  }

  //互动
  re_interaction(data) {
    let modelData = {
      type: '', // 评论，送花1，送花2，送花3，送花4，分享，意见反馈，收藏,视频下载
      contentype: '', //  互动主体 直播，录播，资讯，病例，站内信，论坛 专题
      contentid: '', // 内容id
      contentname: '',
      first_cate: '', //一级分类
      second_cate: '', // 2级分类
      first_cate_id: '', // 1级分类id
      second_cate_id: '', //2级分类id
      author: '', //讲师/作者
      page_location: '' //位置 站内，专区内，超级面对面内
    };
    modelData.page_location = this.location_func();
    this.typeList.forEach(item => {
      if (item.value == data.contentype) {
        data.contentype = item.label;
      }
    });
    this.saEvent('re_interaction', {
      ...modelData,
      ...data
    });
  }

  //专区
  re_zone(data) {
    let modelData = {
      event_type: '', // 进入 / 点击 / 分享
      zonename: '', // 消费类型 直播，录播，资讯，病例，看课时长上报
      zoneid: '' // 内容名字
      // contentname: '', // 直播时间/发布时间 直播是直播时间，录播是发布时间，资讯、病例是发布时间
      // contentid: '', // 内容id
      // first_cate: '', //一级分类
      // second_cate: '', // 2级分类
      // first_cate_id:  '',    // 1级分类id
      // second_cate_id:'', //2级分类id
      // contentype:'' // 内容类型
    };
    this.typeList.forEach(item => {
      if (item.value == data.contentype) {
        data.contentype = item.label;
      }
    });
    this.saEvent('re_zone', {
      ...modelData,
      ...data
    });
  }

  // 活动
  re_activity(data) {
    let modelData = {
      name: '', // 活动名称
      event_type: '' // 活动事件类型
    };
    this.saEvent('re_activity', {
      ...modelData,
      ...data
    });
  }

  // 活动
  re_click(data) {
    let modelData = {
      target_name: '', // 点击目标名字
      target_contentname: '', //点击目标的标题
      target_contentid: '', //点击目标的id
      target_contenturl: '' //点击目标的url
    };
    this.saEvent('re_click', {
      ...modelData,
      ...data
    });
  }

  re_userinfo(data) {
    let modelData = {
      userid: '', // 用户id
      action_type: '', //类型
      register_channel: '', //注册来源 授权，注册，登录，完善信息，认证
      meeting_id: '' //会议id
    };
    this.saEvent('re_userinfo', {
      ...modelData,
      ...data
    });
  }
}
